// Module
var code = " <div layout=\"row\" class=\"full-height\" ng-mouseenter=\"$ctrl.canCopy=true\" ng-mouseleave=\"$ctrl.canCopy=false\"> <a class=\"br-link-1 text-ellipsis\" ui-sref=\"planning-route({id: $ctrl.id})\" ng-click=\"$event.stopPropagation()\"> {{$ctrl.id}} </a> <text-copy-button ng-if=\"$ctrl.canCopy\" text=\"$ctrl.id\"></text-copy-button> </div> ";
// Exports
export default code;